import { render } from "./UseManualList.vue?vue&type=template&id=91afc504&scoped=true&ts=true"
import script from "./useManualListHelper.ts?vue&type=script&lang=ts"
export * from "./useManualListHelper.ts?vue&type=script&lang=ts"

import "./UseManualList.vue?vue&type=style&index=0&id=91afc504&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91afc504"]])

export default __exports__